import { Box, Scroll } from 'folds';
import { PageContent, SettingsSectionPage } from '$components/page';
import { SystemNotification } from './SystemNotification';
import { AllMessagesNotifications } from './AllMessages';
import { SpecialMessagesNotifications } from './SpecialMessages';
import { KeywordMessagesNotifications } from './KeywordMessages';

type NotificationsProps = {
  requestBack?: () => void;
  requestClose: () => void;
};
export function Notifications({ requestBack, requestClose }: NotificationsProps) {
  return (
    <SettingsSectionPage
      title="Notifications"
      requestBack={requestBack}
      requestClose={requestClose}
    >
      <Box grow="Yes">
        <Scroll hideTrack visibility="Hover">
          <PageContent>
            <Box direction="Column" gap="700">
              <SystemNotification />
              <AllMessagesNotifications />
              <SpecialMessagesNotifications />
              <KeywordMessagesNotifications />
            </Box>
          </PageContent>
        </Scroll>
      </Box>
    </SettingsSectionPage>
  );
}
